import { MatSnackBarConfig } from '@angular/material/snack-bar';

export interface FeedbackData {
	title: string;
	message: string;
	placeholder?: string;
	style?: FeedbackStyle;
	inputType?: FeedbackInputType;
	callback?: any;
	okButton?: string;
	cancelButton?: string;
	contentClass?: string;
}

export enum FeedbackInputType {
	number = 'number',
	text = 'text',
	password = 'password',
	email = 'email',
	confirm = 'confirm'
}

export enum FeedbackStyle {
	plain = 'plain',
	error = 'error',
	success = 'success'
}

export enum FeedbackTitle {
	error = 'error',
	success = 'success',
	attention = 'attention',
	warning = 'warning'
}

export interface NotificationData {
	msg: string;
	action?: string;
	config?: MatSnackBarConfig;
}
